import script from "./Notifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notifications.vue?vue&type=script&lang=ts&setup=true"

import "./Notifications.vue?vue&type=style&index=0&id=e8e7f45e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8e7f45e"]])

export default __exports__